export const contactData = {
  title: "Kontakt",
  subtitle: "So findest du uns!",

  address: {
    title: "Hier wird geangelt!",
    street: "Eichwalder Ausbau",
    city: "15537 Gosen-Neu Zittau",
    icon: "FaMapMarkerAlt",
  },

  email: {
    address: "info@angelfreunde1866.de",
    icon: "FaEnvelope",
  },

};

export const privateAddressData = {

  address: {
    title: "Vereinssitz",
    street: "Hausburgstraße 13",
    city: "10249 Berlin / Friedrichshain",
    icon: "FaMapMarkerAlt",
  },

  email: {
    address: "info@angelfreunde1866.de",
    icon: "FaEnvelope",
  },

};
